import {createRoot} from "react-dom/client"
import {
    RouterProvider,
    useLocation,
    Outlet,
} from "react-router-dom"
import axios from "axios"
import {datadogRum} from "@datadog/browser-rum"
import {reactPlugin} from "@datadog/browser-rum-react"
import {createBrowserRouter} from "@datadog/browser-rum-react/react-router-v6"

import {routes} from "./routes"
import pkg from "../package.json"

// Import appropriate css files once here
import "bootstrap/dist/css/bootstrap.css"
import "bootstrap/dist/css/bootstrap.min.css"
import "primereact/resources/themes/lara-light-indigo/theme.css"
import "primereact/resources/primereact.min.css"
import "./static/icons/style.css"
import "./static/css/style.bundle.css"
import "./static/css/plugins.bundle.css"
import "./static/css/blue-theme.css"
import "./static/css/global.css"
import "./static/css/custom-datatable.css"
import "./static/css/custom-survey.css"

axios.defaults.baseURL = window.__APP_CONFIG__?.API_URL ? `${window.__APP_CONFIG__?.API_URL}/api` : "/api"

export function Root() {
    const location = useLocation()

    return (
        <div className="App">
            <Outlet context={{pathname: location.pathname}} />
        </div>
    )
}

datadogRum.init({
    applicationId: window.__APP_CONFIG__?.DATADOG_APP_ID,
    clientToken: window.__APP_CONFIG__?.DATADOG_CLIENT_TOKEN,
    site: window.__APP_CONFIG__?.DATADOG_SITE,
    service: "oars",
    env: window.__APP_CONFIG__?.ENV || "dev",
    version: pkg.version,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 100,
    trackResources: true,
    trackUserInteractions: true,
    trackLongTasks: true,
    defaultPrivacyLevel: "mask-user-input",

    plugins: [reactPlugin({router: false})],
})

const router = createBrowserRouter(routes)

const root = createRoot(document.getElementById("root"))
root.render(<RouterProvider router={router} basename={import.meta.env.PUBLIC_URL} />)
